import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { DetailDrawerComponent } from '@netfoundry-ui/ui/detail-drawer';
import { ZitiConnectionStatusComponent } from './ziti-connection-status/ziti-connection-status.component';
import { ZitiStatusIndicatorComponent } from './ziti-status-indicator/ziti-status-indicator.component';
import { ZitiMetricsPanelComponent } from './ziti-metrics-panel/ziti-metrics-panel.component';

@NgModule({
    declarations: [
        ZitiConnectionStatusComponent,
        ZitiStatusIndicatorComponent,
        ZitiMetricsPanelComponent,
    ],
    imports: [CommonModule, MatTooltipModule, MatDialogModule, DetailDrawerComponent],
    exports: [
        ZitiConnectionStatusComponent,
        ZitiStatusIndicatorComponent,
        ZitiMetricsPanelComponent,
    ],
})
export class ZitiWasmModule {}
